import React from 'react';

export const HeroIllustration = ({ className }) => (
  <svg viewBox="0 0 500 420" className={className} xmlns="http://www.w3.org/2000/svg" role="img" aria-label="AllesBon cadeaubonnen">
    <defs>
      <linearGradient id="heroCardGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FFA89A" />
        <stop offset="100%" stopColor="#E8484F" />
      </linearGradient>
      <linearGradient id="heroCardShine" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stopColor="#fff" stopOpacity="0.25" />
        <stop offset="100%" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </defs>

    <circle cx="250" cy="220" r="190" fill="rgba(255,255,255,0.18)" />
    <circle cx="250" cy="220" r="135" fill="rgba(255,255,255,0.12)" />

    <g transform="rotate(9 290 260)">
      <rect x="170" y="180" width="260" height="150" rx="20" fill="#3D1E5C" opacity="0.92" />
      <rect x="190" y="205" width="80" height="8" rx="4" fill="rgba(255,255,255,0.45)" />
      <rect x="190" y="225" width="140" height="22" rx="4" fill="rgba(255,255,255,0.85)" />
      <circle cx="395" cy="210" r="10" fill="#F4C95D" />
      <rect x="190" y="290" width="60" height="6" rx="3" fill="rgba(255,255,255,0.5)" />
    </g>

    <g transform="rotate(-7 220 220)">
      <rect x="70" y="135" width="290" height="170" rx="22" fill="url(#heroCardGrad)" />
      <rect x="70" y="135" width="290" height="170" rx="22" fill="url(#heroCardShine)" />

      <circle cx="105" cy="170" r="14" fill="#fff" />
      <circle cx="105" cy="170" r="7" fill="#E8484F" />

      <rect x="135" y="163" width="80" height="6" rx="3" fill="rgba(255,255,255,0.75)" />
      <rect x="135" y="175" width="60" height="6" rx="3" fill="rgba(255,255,255,0.5)" />

      <text x="90" y="245" fill="#fff" fontSize="44" fontWeight="700" fontFamily="Fraunces, Barlow Condensed, serif">€50</text>
      <rect x="92" y="262" width="80" height="6" rx="3" fill="rgba(255,255,255,0.6)" />

      <path d="M325 170 L328 180 L338 183 L328 186 L325 196 L322 186 L312 183 L322 180 Z" fill="#F4C95D" />
      <circle cx="325" cy="270" r="6" fill="rgba(255,255,255,0.7)" />
    </g>

    <circle cx="55" cy="80" r="7" fill="#F4C95D" />
    <circle cx="455" cy="95" r="6" fill="#E8484F" />
    <circle cx="35" cy="345" r="8" fill="#6B3FA0" />
    <circle cx="470" cy="330" r="6" fill="#FFA89A" />
    <rect x="430" y="225" width="12" height="12" rx="3" transform="rotate(25 436 231)" fill="#F4C95D" />
    <rect x="48" y="205" width="11" height="11" rx="2" transform="rotate(-22 53 210)" fill="#3D1E5C" />
    <path d="M90 365 L93 373 L101 376 L93 379 L90 387 L87 379 L79 376 L87 373 Z" fill="#fff" />
    <path d="M420 385 L422 391 L428 393 L422 395 L420 401 L418 395 L412 393 L418 391 Z" fill="#F4C95D" />
  </svg>
);

export const ReachIllustration = ({ className }) => (
  <svg viewBox="0 0 500 420" className={className} xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Cadeaubonnen kopen via je telefoon">
    <defs>
      <linearGradient id="reachPhoneGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FF8A75" />
        <stop offset="100%" stopColor="#E8484F" />
      </linearGradient>
    </defs>

    <ellipse cx="250" cy="240" rx="210" ry="170" fill="#FCEDEA" />

    <g>
      <rect x="170" y="55" width="160" height="320" rx="26" fill="#3D1E5C" />
      <rect x="178" y="73" width="144" height="284" rx="16" fill="#FFF8F0" />

      <rect x="218" y="83" width="64" height="6" rx="3" fill="#3D1E5C" opacity="0.25" />

      <rect x="190" y="105" width="120" height="64" rx="12" fill="url(#reachPhoneGrad)" />
      <rect x="200" y="120" width="44" height="5" rx="2" fill="rgba(255,255,255,0.55)" />
      <text x="200" y="153" fill="#fff" fontSize="20" fontWeight="700" fontFamily="Fraunces, serif">€25</text>
      <circle cx="295" cy="120" r="6" fill="#F4C95D" />

      <rect x="190" y="183" width="120" height="40" rx="9" fill="#FCEDEA" />
      <circle cx="210" cy="203" r="11" fill="#FFA89A" />
      <rect x="228" y="196" width="60" height="5" rx="2" fill="#3D1E5C" opacity="0.7" />
      <rect x="228" y="207" width="40" height="4" rx="2" fill="#3D1E5C" opacity="0.4" />

      <rect x="190" y="231" width="120" height="40" rx="9" fill="#FCEDEA" />
      <circle cx="210" cy="251" r="11" fill="#F4C95D" />
      <rect x="228" y="244" width="70" height="5" rx="2" fill="#3D1E5C" opacity="0.7" />
      <rect x="228" y="255" width="50" height="4" rx="2" fill="#3D1E5C" opacity="0.4" />

      <rect x="190" y="279" width="120" height="40" rx="9" fill="#FCEDEA" />
      <circle cx="210" cy="299" r="11" fill="#6B3FA0" />
      <rect x="228" y="292" width="50" height="5" rx="2" fill="#3D1E5C" opacity="0.7" />
      <rect x="228" y="303" width="60" height="4" rx="2" fill="#3D1E5C" opacity="0.4" />

      <rect x="190" y="328" width="120" height="30" rx="15" fill="#E8484F" />
      <rect x="226" y="340" width="48" height="6" rx="3" fill="#fff" />
    </g>

    <g transform="translate(75, 110)">
      <circle cx="0" cy="0" r="34" fill="#fff" />
      <path d="M0 -6 C-6 -14, -18 -14, -18 -2 C-18 8, 0 18, 0 18 C0 18, 18 8, 18 -2 C18 -14, 6 -14, 0 -6 Z" fill="#E8484F" />
    </g>

    <g transform="translate(395, 130) rotate(14)">
      <rect x="-34" y="-20" width="68" height="40" rx="12" fill="#fff" />
      <text x="0" y="7" textAnchor="middle" fill="#3D1E5C" fontSize="16" fontWeight="700" fontFamily="Fraunces, serif">€50</text>
    </g>

    <g transform="translate(80, 320)">
      <circle cx="0" cy="0" r="32" fill="#fff" />
      <path d="M-11 -6 L-11 -10 C-11 -17, 11 -17, 11 -10 L11 -6 M-13 -6 L13 -6 L11 16 L-11 16 Z" stroke="#F4C95D" strokeWidth="3" fill="none" strokeLinejoin="round" />
    </g>

    <path d="M395 285 L398 293 L406 296 L398 299 L395 307 L392 299 L384 296 L392 293 Z" fill="#F4C95D" />
    <circle cx="430" cy="225" r="5" fill="#FF6B6B" />
    <circle cx="50" cy="225" r="4" fill="#6B3FA0" />
    <circle cx="55" cy="55" r="3" fill="#F4C95D" />
    <circle cx="445" cy="370" r="5" fill="#FFA89A" />
    <path d="M40 280 L42 286 L48 288 L42 290 L40 296 L38 290 L32 288 L38 286 Z" fill="#3D1E5C" />
  </svg>
);
